import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export type SlaExportView = 'services' | 'tasks';

export interface SlaExportParams {
  view: SlaExportView;
  slaStatus?: string;
  status?: string;
  serviceStatus?: string;
  taskStatus?: string;
  pendingOn?: string;
  companyId?: number;
  corporationId?: number;
  assignedAgentFirmId?: string;
  assignedUserId?: string;
  productId?: string;
  search?: string;
}

interface TriggerSlaExportResponse {
  jobId: string;
}

export interface SlaExportStatusResponse {
  status: 'processing' | 'completed' | 'failed';
  signedUrl?: string;
  error?: string;
}

export async function triggerSlaExport(
  params: SlaExportParams
): Promise<TriggerSlaExportResponse> {
  const res = await fetcher(`${API_BASE_PATH}/sla/export`, {
    method: 'POST',
    body: params,
  });

  if (!res.ok) {
    const error = await res.json().catch(() => ({ message: 'Export failed' }));
    throw new Error(error.message || 'Failed to start SLA export');
  }

  return res.json();
}

export async function getSlaExportStatus(
  jobId: string
): Promise<SlaExportStatusResponse> {
  const res = await fetcher(
    `${API_BASE_PATH}/sla/export/status?jobId=${encodeURIComponent(jobId)}`,
    { method: 'GET' },
  );

  if (!res.ok) {
    const error = await res.json().catch(() => ({ message: 'Status check failed' }));
    throw new Error(error.message || 'Failed to check export status');
  }

  return res.json();
}
